import React from "react";
import { Button, DatePicker } from "sulu-admin-bundle/components";

const MatchDayDelete = ({ action, datetime, handleTimeChange }) => {
  return (
    <div className="matches__timecontainer">
      <DatePicker
        options={{
          timeFormat: true,
        }}
        value={datetime}
        onChange={handleTimeChange}
      />

      <Button
        iconClassName="matches__deleteicon"
        className="matches__deletebutton"
        size="small"
        skin="icon"
        icon="su-times"
        onClick={action}
      />
    </div>
  );
};

export default MatchDayDelete;
